import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  DatePicker,
  Typography,
  Table,
  Space,
  Card,
  Select,
  Collapse,
  Tooltip,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Descriptions,
  Button,
  Divider,
  Statistic,
  Modal,
} from "antd";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../group.config";

import styles from "../../../assets/styles/styles";
import dayjs from "dayjs";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewGroup = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const isActive = Form.useWatch("active", useForm);

  // CHARGES FORM REQURED VARIABLES
  const [customerTableSource, setCustomerTableSource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [officeId, setOfficeId] = useState("");

  useEffect(() => {
    setIsLoading(false);
    defaultDate();
    getTemplate();
  }, []);

  const defaultDate = () => {
    useForm.setFieldsValue({
      submittedOnDate: dayjs(),
      activationDate: dayjs(),
    });
  };

  function getTemplate() {
    const params = {
      orderBy: "name",
      sortOrder: "ASC",
      staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.Groups}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempOfficeData = [];
        let tempStaffData = [];

        objDetail?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setOfficeData(tempOfficeData);
        setActivationDate(objDetail?.activationDate);
        setStaffData(tempStaffData);
        setIsLoading(false);
      }
    });
  }

  const onChangeOffice = (officeParam) => {
    setOfficeId(officeParam);
    setCustomerTableSource([]);
    setIsCustomerSelected(false);
    const params = {
      officeId: officeParam,
      staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.Groups}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempStaffData = [];

        objList?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setStaffData(tempStaffData);
        setIsLoading(false);
      }
    });
  };

  const handleCustomerDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = customerTableSource.filter(
          (item) => item.id !== key.id
        );
        setCustomerTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  function onCancel() {
    navigate("/manage-group", { replace: false });
  }

  const columns = [
    {
      title: labelConfig.id,
      dataIndex: "id",
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
    },
    {
      title: labelConfig.branch,
      dataIndex: "office",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        customerTableSource.length >= 1 ? (
          <Tooltip title={`Remove Customer`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleCustomerDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const onSubmit = (formValues) => {
    let tempCustomerArray = [];
    customerTableSource.forEach((element, index) => {
      tempCustomerArray.push(element.id);
    });

    formValues.clientMembers = tempCustomerArray;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.locale = "en";

    // console.log(formValues);
    // return;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Groups, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newGroupMsg);
        navigate("/detail-group", {
          state: {
            id: res.groupId,
            // statusValue: accountStatus.submittedAndPending,
          },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newGroup}
        pageItems={staticConfig.newBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: false,
              isStaff: false,
              openCasa: false,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.groupSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.office}
                  name="officeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.office),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.office}`,
                      "select"
                    )}
                    options={officeData}
                    onChange={onChangeOffice}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.name}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.name),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.externalID} name="externalId">
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.externalID
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.relationshipManager}
                  name="staffId"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.relationshipManager,
                      "select"
                    )}
                    options={staffData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.isActive} name="active">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.isActive}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {isActive && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.activationDate}
                    name="activationDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.activationDate),
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.activationDate,
                        "select"
                      )}
                      style={{ width: "100%", height: 35 }}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.submittedDate}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.submittedDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.submittedDate,
                      "select"
                    )}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.customerInfo}
              </Title>
            </Divider>
            <AddCustomerModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setCustomerTableSource={setCustomerTableSource}
              customerTableSource={customerTableSource}
              session={session}
              officeId={officeId}
              isCustomerSelected={isCustomerSelected}
              setIsCustomerSelected={setIsCustomerSelected}
            />

            {customerTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {customerTableSource.length > 1
                      ? labelConfig.selectedCustomers
                      : labelConfig.selectedCustomer}
                  </Title>
                </Divider>
                <Table
                  columns={columns}
                  dataSource={customerTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_GROUP") &&
                <CustomButton
                  content="Submit"
                  disabled
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              }

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewGroup);

const AddCustomerModal = (props) => {
  const {
    session,
    setCustomerTableSource,
    customerTableSource,
    isModalOpen,
    setIsModalOpen,
    officeId,
    isCustomerSelected,
    setIsCustomerSelected,
  } = props;

  const [useForm] = Form.useForm();
  const [customerData, setCustomerData] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [currentCustomerDetails, setCurrentCustomerDetails] = useState({});
  // const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const onSearch = (officeId) => {
    // console.log(officeId);

    setIsCustomerSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    const params = {
      displayName: searchParam.trim(),
      officeId: officeId ? officeId : null,
      orderBy: "displayName",
      orphansOnly: true,
      sortOrder: "ASC",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        // setSearchParam("");
      } else {
        const objList = res.pageItems;
        let tempCustomerData = [];
        let tempCustomerDetails = [];

        objList?.forEach((element) => {
          tempCustomerData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.forEach((element) => {
          tempCustomerDetails.push({
            key: element.id,
            id: element.id,
            name: element.displayName,
            office: element.officeName,
          });
        });

        if (tempCustomerData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching Customer found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerData(tempCustomerData);
        setCustomerDetails(tempCustomerDetails);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomerSave = (formValues) => {
    const newCustomer = customerDetails?.find(
      (item) => item.id === formValues.customerId
    );

    let foundCharge = customerTableSource.find(
      (item) => item.id === newCustomer?.id
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Customer allowed!");
      return;
    }
    setCustomerTableSource([...customerTableSource, newCustomer]);

    useForm.resetFields();
  };

  const onChangeCustomer = (customerParam) => {
    const currentCustomerDetails = customerDetails?.find(
      (item) => item.id === customerParam
    );
    setCurrentCustomerDetails(currentCustomerDetails);
    setIsCustomerSelected(true);
  };

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: customerDetails ? currentCustomerDetails.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: customerDetails ? currentCustomerDetails.name : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.branch,
      children: customerDetails ? currentCustomerDetails.office : "-",
      span: 3,
    },
  ];

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        size="medium"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Add Customer to a group"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCustomerSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Space.Compact
                style={{
                  width: "100%",
                }}
              >
                <div>
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by Customer Name"
                    style={{ width: 400 }}
                    allowClear
                  />
                </div>
                <Button
                  type="primary"
                  className="of-primaryBtnColor"
                  onClick={() => onSearch(officeId)}
                >
                  <SearchOutlined />
                </Button>
              </Space.Compact>
            </Col>
          </Row>
          {showDetailsForm && (
            <>
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.selectCustomer}
                  </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.customerList}
                    name={"customerId"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.customer),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.customer,
                        "select"
                      )}
                      options={customerData}
                      showSearch
                      onChange={onChangeCustomer}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {isCustomerSelected && (
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          )}
        </Spin>
      </Modal>
    </Row>
  );
};
